import forma_model from '@/shared/models/forma_model';
import materia_prima_familia_model from '@/shared/models/materia_prima_familia_model';
import proceso_model from '@/shared/models/proceso_model';
import resource_model from '@/views/resource/models/resource_model';

export default {
  Codigo: null,
  CodigoOrdenProduccion: null,
  CodigoSeccion: 1,
  CodigoOrdenProduccionElemento: null,
  CodigoProceso: null,
  ItemProceso: 1,
  CodigoRecurso: 1,
  CodigoMateriaPrimaFamilia: null,
  Porcentaje: null,
  Observaciones: null,
  Proceso: { ...proceso_model },
  Recurso: JSON.parse(JSON.stringify(resource_model)),
  MateriaPrimaFamilia: { ...materia_prima_familia_model },
  Forma: { ...forma_model },
  Velocidad: null,
  VelocidadManual: null,
  Cantidad: null,
  Costo: null,
  Adicional: false,
  // COTI-642: proceso raiz del flujo (sin precedente) -- hint para el diagrama.
  EsProcesoInicial: false,
  PorcentajeMerma: 0,
  CodigoSentidoBobinado: null,
  OrdenProduccionElementoProcesoMateriales: [],
  CodigoExtrusionTipo: null,
  EspesorResultante: null,
  GramajeResultante: null,
  DensidadResultante: null,
  CantidadCapas: 1,
  ElementoProcesoBobinas: [],
  ElementoProcesoTornillos: [],
};
